import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

export const ModalWrapper = styled.div`
  width: 525px;
  height: 258px;
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color[2]};
  box-shadow: 4px 4px 15px 0 #00000040;
`;

export const Title = styled.p`
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  color: #151619;
  margin-bottom: 12px;
`;

export const Content = styled.p`
  ${({ theme }) => theme.typography.MEDIUM_16};
  color: ${({ theme }) => theme.color[4]};
  margin-bottom: 8px;
`;

export const ErrorMessage = styled.p`
  ${({ theme }) => theme.typography.REGULAR_12};
  color: ${({ theme }) => theme.color.warningRed};
`;
